import { render, staticRenderFns } from "./EmailConfig.vue?vue&type=template&id=7556c1e7&scoped=true"
import script from "./EmailConfig.vue?vue&type=script&lang=ts"
export * from "./EmailConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7556c1e7",
  null
  
)

export default component.exports